import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"
import { SperrGrund } from "@/hilfe/Knopfhilfe"

// grund: wie am <Button> (Auftrag 8, R3) -- warum der Haken gesperrt ist.
// Ohne grund bleibt er, wie er war.
const Checkbox = React.forwardRef(({ className, ...rest }, ref) => {
  const { grund, ...props } = rest
  const haken = (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
  )
  if (props.disabled && Object.prototype.hasOwnProperty.call(rest, "grund")) {
    return <SperrGrund grund={grund} className={className} testId={props["data-testid"]}>{haken}</SperrGrund>
  }
  return haken
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
